import * as yup from "yup";

/** Valores validados del flujo de carga automática desde el link público. */
export interface SendAutomaticInvoicePublicValues {
  ccEmail: string;
}

/**
 * Esquema de validación para el flujo de carga automática desde el link público (sin login).
 */
export const sendAutomaticInvoicePublicSchema: yup.ObjectSchema<SendAutomaticInvoicePublicValues> = yup
  .object()
  .shape({
    ccEmail: yup.string().email("Debe ser un correo válido").required("Es Requerido"),
  })
  .required();
